module.exports = __webpack_public_path__ + "img/arrow_white.b32bc6a9.png";